import React from "react";
import EntityList from "../EntityList/EntityList";

class DisplayList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSort = this.handleSort.bind(this);
    //Entities are copied to the state because they can change?
    // but if entities come from the parent shouldn't I change it there?
    // what will I do after an update in the list?
    // the easiest would be to just request the list once again
    // and fetch the updates
    this.state = {
      entities: [],
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  handleToggle({ event, field, entity }) {
    //If successful fetch the list once again
    //this should belong to the HoC?

    //this should call the api, change the status
    //if successful fetch the list once again and show it
    //if error show error.
    //it should show a loader while updating

    //this behaviour is reusable so it should belong in the HoC

    event.preventDefault();
    event.stopPropagation();
    console.log("toggled ");
    console.log(field);
    console.log(entity);
    this.props.onToggleListItem({
      id: entity.id,
      entity,
      activeProperty: "active",
      binary: true
    });
  }
  handleDelete({ event, entity }) {
    //If successful fetch the list once again
    //this should belong to the HoC?

    //this should call the api, change the status
    //if successful fetch the list once again and show it
    //if error show error.
    //it should show a loader while updating

    //this behaviour is reusable so it should belong in the HoC

    event.preventDefault();
    event.stopPropagation();
    console.log("deleted ");
    console.log(entity);
    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
    });
  }

  handleSort({ event, field, entity, newIndex, oldIndex, swappedEntity }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    console.log("sorted ", {
      id: entity.id,
      entity,
      field,
      newIndex,
      swappedEntity,
      oldIndex,
    });
    console.log(entity);
    return this.props.onSortListItem({
      id: entity.id,
      entity,
      field,
      newIndex,
      swappedEntity,
      oldIndex,
      binary: true
    });
  }

  render() {
    const { config } = this.props;
    const { name, entityName, validation, fields, renderers, sorting, reorder } = config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      success,
    } = this.props;
    const { handleToggle, handleDelete, handleSort } = this;
    return (
      <EntityList
        loading={loading}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        onToggle={handleToggle}
        onDelete={handleDelete}
        onSort={handleSort}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        sorting={sorting}
        success={success}
        reorder={reorder}
        onReorder={handleSort}
      />
    );
  }
}

DisplayList.propTypes = {};

DisplayList.defaultProps = {
  entities: [],
};

export default DisplayList;
